"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENotificationGroupType = exports.EMediaType = exports.EFontCategory = exports.EInProgressDevotionalStatus = exports.EDevotionalSearchOrderBy = exports.EDevotionalApprovalStatus = exports.KeysetPaginationDirection = exports.ECommentAppOrderBy = exports.EProfileDisableReason = exports.ETimeOutOrderBy = exports.ETimeFrame = exports.EResetPasswordStatus = exports.EReportOrderBy = exports.EReportType = exports.EReportStatus = exports.EReportObjectType = exports.EProfileOrderBy = exports.EPostOrderBy = exports.EPostPublishedStatus = exports.EPostType = exports.EPostStatus = exports.EPostAttachmentType = exports.ELoginType = exports.EAdminLogOrderBy = exports.EAdminLogAction = exports.EGlobalPushNotificationOrderBy = exports.EGlobalPushNotificationLinkObject = exports.EGlobalPushNotificationStatus = exports.EGlobalPushNotificationType = exports.EProfileStatus = exports.EFollowApprovalStatus = exports.EListElementType = exports.EHeaderElementType = exports.EVerseType = exports.EDevotionalElementType = exports.EDevotionalCoverImageTextLayerAlignment = exports.EDevotionalCoverImageLayerType = exports.EDevotionalOrderBy = exports.EDevotionalStatus = exports.EWarningReason = exports.ECommentOrderBy = exports.ECommentStatus = exports.EBusinessType = exports.EPagingOrderByDirection = exports.EAlertOrderBy = exports.EProfileType = exports.EAlertAction = exports.EAlertType = exports.GrowClient = exports.BaseClient = void 0;
exports.ApiException = exports.EWarningOrderBy = exports.EWarningType = exports.EWarningStatus = exports.EProfileSearchType = exports.EPopUpInteractionResult = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
class BaseClient {
    constructor() {
        this.getBaseUrl = (str, baseUrl) => {
            return baseUrl || process.env.REACT_APP_API_URL;
        };
        this.transformOptions = (options) => {
            return Promise.resolve(options);
        };
    }
    transformResult(url, response, processor) {
        return processor(response);
    }
}
exports.BaseClient = BaseClient;
class GrowClient extends BaseClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }
    adminGetAlerts(cursor, query, read, type, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/alert?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (read !== undefined && read !== null)
            url_ += "Read=" + encodeURIComponent("" + read) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetAlerts(_response));
        });
    }
    processAdminGetAlerts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileAlerts(profileId, cursor, query, read, type, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/alert/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (read !== undefined && read !== null)
            url_ += "Read=" + encodeURIComponent("" + read) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileAlerts(_response));
        });
    }
    processAdminGetProfileAlerts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminMarkAlertAsRead(id, value, signal) {
        let url_ = this.baseUrl + "/api/admin/alert/read/{id}/{value}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminMarkAlertAsRead(_response));
        });
    }
    processAdminMarkAlertAsRead(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetUserBusinessMembers(userProfileId, signal) {
        let url_ = this.baseUrl + "/api/admin/businessmember/user/{userProfileId}";
        if (userProfileId === undefined || userProfileId === null)
            throw new Error("The parameter 'userProfileId' must be defined.");
        url_ = url_.replace("{userProfileId}", encodeURIComponent("" + userProfileId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetUserBusinessMembers(_response));
        });
    }
    processAdminGetUserBusinessMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBusinessBusinessMembers(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/admin/businessmember/business/{businessProfileId}";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBusinessBusinessMembers(_response));
        });
    }
    processAdminGetBusinessBusinessMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetComments(cursor, query, status, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/comment?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetComments(_response));
        });
    }
    processAdminGetComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetComment(id, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetComment(_response));
        });
    }
    processAdminGetComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileComments(profileId, cursor, query, status, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileComments(_response));
        });
    }
    processAdminGetProfileComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetDevotionalComments(devotionalId, cursor, query, status, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/devotional/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetDevotionalComments(_response));
        });
    }
    processAdminGetDevotionalComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPostComments(postId, cursor, query, status, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/post/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPostComments(_response));
        });
    }
    processAdminGetPostComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetCommentReplies(id, cursor, query, status, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/replies/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetCommentReplies(_response));
        });
    }
    processAdminGetCommentReplies(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBanComment(banResource, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/ban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(banResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBanComment(_response));
        });
    }
    processAdminBanComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnbanComment(commentId, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/unban/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnbanComment(_response));
        });
    }
    processAdminUnbanComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetCommentHistory(id, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/history/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetCommentHistory(_response));
        });
    }
    processAdminGetCommentHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetCommentEntitiesCount(id, signal) {
        let url_ = this.baseUrl + "/api/admin/comment/entitiescount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetCommentEntitiesCount(_response));
        });
    }
    processAdminGetCommentEntitiesCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetUserDevices(userProfileId, signal) {
        let url_ = this.baseUrl + "/api/admin/device/user/{userProfileId}";
        if (userProfileId === undefined || userProfileId === null)
            throw new Error("The parameter 'userProfileId' must be defined.");
        url_ = url_.replace("{userProfileId}", encodeURIComponent("" + userProfileId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetUserDevices(_response));
        });
    }
    processAdminGetUserDevices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetDevotionals(cursor, query, status, isPublic, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isPublic !== undefined && isPublic !== null)
            url_ += "IsPublic=" + encodeURIComponent("" + isPublic) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetDevotionals(_response));
        });
    }
    processAdminGetDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetDevotional(id, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetDevotional(_response));
        });
    }
    processAdminGetDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBanDevotional(banResource, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional/ban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(banResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBanDevotional(_response));
        });
    }
    processAdminBanDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnbanDevotional(unbanDevotionalResource, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional/unban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(unbanDevotionalResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnbanDevotional(_response));
        });
    }
    processAdminUnbanDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminVerifyDevotional(id, verify, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional/verify/{id}/{verify}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (verify === undefined || verify === null)
            throw new Error("The parameter 'verify' must be defined.");
        url_ = url_.replace("{verify}", encodeURIComponent("" + verify));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminVerifyDevotional(_response));
        });
    }
    processAdminVerifyDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetDevotionalEntitiesCount(id, signal) {
        let url_ = this.baseUrl + "/api/admin/devotional/entitiescount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetDevotionalEntitiesCount(_response));
        });
    }
    processAdminGetDevotionalEntitiesCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetSentFollowApprovals(profileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/followapproval/sent/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetSentFollowApprovals(_response));
        });
    }
    processAdminGetSentFollowApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetReceivedFollowApprovals(profileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/followapproval/received/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetReceivedFollowApprovals(_response));
        });
    }
    processAdminGetReceivedFollowApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileFollowers(profileId, cursor, query, signal) {
        let url_ = this.baseUrl + "/api/admin/follow/followers/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileFollowers(_response));
        });
    }
    processAdminGetProfileFollowers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileFollowings(profileId, cursor, query, signal) {
        let url_ = this.baseUrl + "/api/admin/follow/followings/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileFollowings(_response));
        });
    }
    processAdminGetProfileFollowings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetGlobalPushNotifications(cursor, query, linkObject, status, type, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/globalpushnotification?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (linkObject !== undefined && linkObject !== null)
            url_ += "LinkObject=" + encodeURIComponent("" + linkObject) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetGlobalPushNotifications(_response));
        });
    }
    processAdminGetGlobalPushNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCreateGlobalPushNotification(createGlobalPushNotificationResource, signal) {
        let url_ = this.baseUrl + "/api/admin/globalpushnotification";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createGlobalPushNotificationResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCreateGlobalPushNotification(_response));
        });
    }
    processAdminCreateGlobalPushNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetLogs(cursor, query, actions, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/log?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (actions !== undefined && actions !== null)
            actions && actions.forEach(item => { url_ += "Actions=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetLogs(_response));
        });
    }
    processAdminGetLogs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileLogins(profileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/login?";
        if (profileId === null)
            throw new Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileLogins(_response));
        });
    }
    processAdminGetProfileLogins(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPosts(cursor, query, attachmentType, censored, includeInDiscoveryFeed, status, publishedStatus, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/post?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (attachmentType !== undefined && attachmentType !== null)
            url_ += "AttachmentType=" + encodeURIComponent("" + attachmentType) + "&";
        if (censored === null)
            throw new Error("The parameter 'censored' cannot be null.");
        else if (censored !== undefined)
            url_ += "Censored=" + encodeURIComponent("" + censored) + "&";
        if (includeInDiscoveryFeed !== undefined && includeInDiscoveryFeed !== null)
            url_ += "IncludeInDiscoveryFeed=" + encodeURIComponent("" + includeInDiscoveryFeed) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (publishedStatus !== undefined && publishedStatus !== null)
            url_ += "PublishedStatus=" + encodeURIComponent("" + publishedStatus) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPosts(_response));
        });
    }
    processAdminGetPosts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPost(id, signal) {
        let url_ = this.baseUrl + "/api/admin/post/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPost(_response));
        });
    }
    processAdminGetPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfilePosts(profileId, cursor, query, attachmentType, censored, includeInDiscoveryFeed, status, publishedStatus, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/post/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (attachmentType !== undefined && attachmentType !== null)
            url_ += "AttachmentType=" + encodeURIComponent("" + attachmentType) + "&";
        if (censored === null)
            throw new Error("The parameter 'censored' cannot be null.");
        else if (censored !== undefined)
            url_ += "Censored=" + encodeURIComponent("" + censored) + "&";
        if (includeInDiscoveryFeed !== undefined && includeInDiscoveryFeed !== null)
            url_ += "IncludeInDiscoveryFeed=" + encodeURIComponent("" + includeInDiscoveryFeed) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (publishedStatus !== undefined && publishedStatus !== null)
            url_ += "PublishedStatus=" + encodeURIComponent("" + publishedStatus) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfilePosts(_response));
        });
    }
    processAdminGetProfilePosts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPostHistory(id, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/post/history/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPostHistory(_response));
        });
    }
    processAdminGetPostHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBanPost(banResource, signal) {
        let url_ = this.baseUrl + "/api/admin/post/ban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(banResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBanPost(_response));
        });
    }
    processAdminBanPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnbanPost(postId, signal) {
        let url_ = this.baseUrl + "/api/admin/post/unban/{postId}";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnbanPost(_response));
        });
    }
    processAdminUnbanPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCensorImagePost(id, value, signal) {
        let url_ = this.baseUrl + "/api/admin/post/censor/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCensorImagePost(_response));
        });
    }
    processAdminCensorImagePost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminIncludePostInDiscoverFeed(id, value, signal) {
        let url_ = this.baseUrl + "/api/admin/post/discoverfeed/{id}/{value}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminIncludePostInDiscoverFeed(_response));
        });
    }
    processAdminIncludePostInDiscoverFeed(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPostEntitiesCount(id, signal) {
        let url_ = this.baseUrl + "/api/admin/post/entitiescount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPostEntitiesCount(_response));
        });
    }
    processAdminGetPostEntitiesCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPostStatistics(id, signal) {
        let url_ = this.baseUrl + "/api/admin/post/statistics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPostStatistics(_response));
        });
    }
    processAdminGetPostStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBlockedByProfiles(profileId, cursor, query, signal) {
        let url_ = this.baseUrl + "/api/admin/profileblock/blockedby/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBlockedByProfiles(_response));
        });
    }
    processAdminGetBlockedByProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBlockingProfiles(profileId, cursor, query, signal) {
        let url_ = this.baseUrl + "/api/admin/profileblock/blocking/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBlockingProfiles(_response));
        });
    }
    processAdminGetBlockingProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileChanges(profileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/admin/profilechange?";
        if (profileId === null)
            throw new Error("The parameter 'profileId' cannot be null.");
        else if (profileId !== undefined)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileChanges(_response));
        });
    }
    processAdminGetProfileChanges(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfiles(cursor, query, type, imagePendingReview, status, isPrivate, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/profile?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (imagePendingReview === null)
            throw new Error("The parameter 'imagePendingReview' cannot be null.");
        else if (imagePendingReview !== undefined)
            url_ += "ImagePendingReview=" + encodeURIComponent("" + imagePendingReview) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isPrivate !== undefined && isPrivate !== null)
            url_ += "IsPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfiles(_response));
        });
    }
    processAdminGetProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfile(username, signal) {
        let url_ = this.baseUrl + "/api/admin/profile/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfile(_response));
        });
    }
    processAdminGetProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCensorProfileImage(profileId, value, signal) {
        let url_ = this.baseUrl + "/api/admin/profile/censorimage/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCensorProfileImage(_response));
        });
    }
    processAdminCensorProfileImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminProtectProfile(id, value, signal) {
        let url_ = this.baseUrl + "/api/admin/profile/protect/{id}/{value}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminProtectProfile(_response));
        });
    }
    processAdminProtectProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileEntitiesCount(username, signal) {
        let url_ = this.baseUrl + "/api/admin/profile/entitiescount/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileEntitiesCount(_response));
        });
    }
    processAdminGetProfileEntitiesCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCreateProfileWarning(warningResource, signal) {
        let url_ = this.baseUrl + "/api/admin/profile/warning";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(warningResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCreateProfileWarning(_response));
        });
    }
    processAdminCreateProfileWarning(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetReports(cursor, query, status, type, objectType, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/report?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (objectType !== undefined && objectType !== null)
            url_ += "ObjectType=" + encodeURIComponent("" + objectType) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetReports(_response));
        });
    }
    processAdminGetReports(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetReport(id, signal) {
        let url_ = this.baseUrl + "/api/admin/report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetReport(_response));
        });
    }
    processAdminGetReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminResolveReport(id, resolution, signal) {
        let url_ = this.baseUrl + "/api/admin/report/resolve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(resolution);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminResolveReport(_response));
        });
    }
    processAdminResolveReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPasswordResets(profileId, page, signal) {
        let url_ = this.baseUrl + "/api/admin/resetpassword/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPasswordResets(_response));
        });
    }
    processAdminGetPasswordResets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminSetUserProfileRole(setUserProfileRoleResource, signal) {
        let url_ = this.baseUrl + "/api/admin/role";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(setUserProfileRoleResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminSetUserProfileRole(_response));
        });
    }
    processAdminSetUserProfileRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfilesCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/profiles/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfilesCreatedStatistics(_response));
        });
    }
    processAdminGetProfilesCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfilesLoggedInStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/profiles/loggedin/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfilesLoggedInStatistics(_response));
        });
    }
    processAdminGetProfilesLoggedInStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetLoginStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/logins/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetLoginStatistics(_response));
        });
    }
    processAdminGetLoginStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetLikesCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/likes/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetLikesCreatedStatistics(_response));
        });
    }
    processAdminGetLikesCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetPostsCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/posts/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetPostsCreatedStatistics(_response));
        });
    }
    processAdminGetPostsCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetCommentsCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/comments/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetCommentsCreatedStatistics(_response));
        });
    }
    processAdminGetCommentsCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetReportsCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/reports/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetReportsCreatedStatistics(_response));
        });
    }
    processAdminGetReportsCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetInProgressDevotionalsStartedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/inprogressdevotionals/started/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetInProgressDevotionalsStartedStatistics(_response));
        });
    }
    processAdminGetInProgressDevotionalsStartedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetInProgressDevotionalsCompletedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/inprogressdevotionals/completed/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetInProgressDevotionalsCompletedStatistics(_response));
        });
    }
    processAdminGetInProgressDevotionalsCompletedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetFollowsCreatedStatistics(timeFrame, signal) {
        let url_ = this.baseUrl + "/api/admin/stats/follows/created/{timeFrame}";
        if (timeFrame === undefined || timeFrame === null)
            throw new Error("The parameter 'timeFrame' must be defined.");
        url_ = url_.replace("{timeFrame}", encodeURIComponent("" + timeFrame));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetFollowsCreatedStatistics(_response));
        });
    }
    processAdminGetFollowsCreatedStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileAgeStatistics(signal) {
        let url_ = this.baseUrl + "/api/admin/stats/profiles/ages";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileAgeStatistics(_response));
        });
    }
    processAdminGetProfileAgeStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBibleTranslationStats(signal) {
        let url_ = this.baseUrl + "/api/admin/stats/bibletranslations";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBibleTranslationStats(_response));
        });
    }
    processAdminGetBibleTranslationStats(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetTimeOuts(cursor, query, active, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/timeout?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetTimeOuts(_response));
        });
    }
    processAdminGetTimeOuts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCreateTimeOut(timeOutResource, signal) {
        let url_ = this.baseUrl + "/api/admin/timeout";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(timeOutResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCreateTimeOut(_response));
        });
    }
    processAdminCreateTimeOut(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminExpireTimeOut(timeOutId, signal) {
        let url_ = this.baseUrl + "/api/admin/timeout/expire?";
        if (timeOutId === null)
            throw new Error("The parameter 'timeOutId' cannot be null.");
        else if (timeOutId !== undefined)
            url_ += "timeOutId=" + encodeURIComponent("" + timeOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminExpireTimeOut(_response));
        });
    }
    processAdminExpireTimeOut(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getAppUpdateVersions(signal) {
        let url_ = this.baseUrl + "/api/appupdate";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetAppUpdateVersions(_response));
        });
    }
    processGetAppUpdateVersions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    login(loginResource, signal) {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(loginResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processLogin(_response));
        });
    }
    processLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    refresh(signal) {
        let url_ = this.baseUrl + "/api/auth/refresh";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processRefresh(_response));
        });
    }
    processRefresh(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    logOut(signal) {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processLogOut(_response));
        });
    }
    processLogOut(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getScripture(book, chapter, firstVerse, lastVerse, translationCode, signal) {
        let url_ = this.baseUrl + "/api/bible/scripture?";
        if (book !== undefined && book !== null)
            url_ += "book=" + encodeURIComponent("" + book) + "&";
        if (chapter === null)
            throw new Error("The parameter 'chapter' cannot be null.");
        else if (chapter !== undefined)
            url_ += "chapter=" + encodeURIComponent("" + chapter) + "&";
        if (firstVerse === null)
            throw new Error("The parameter 'firstVerse' cannot be null.");
        else if (firstVerse !== undefined)
            url_ += "firstVerse=" + encodeURIComponent("" + firstVerse) + "&";
        if (lastVerse !== undefined && lastVerse !== null)
            url_ += "lastVerse=" + encodeURIComponent("" + lastVerse) + "&";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetScripture(_response));
        });
    }
    processGetScripture(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getKeywordScripture(book, chapter, firstVerse, lastVerse, translationCode, signal) {
        let url_ = this.baseUrl + "/api/bible/keywordscripture?";
        if (book !== undefined && book !== null)
            url_ += "book=" + encodeURIComponent("" + book) + "&";
        if (chapter === null)
            throw new Error("The parameter 'chapter' cannot be null.");
        else if (chapter !== undefined)
            url_ += "chapter=" + encodeURIComponent("" + chapter) + "&";
        if (firstVerse === null)
            throw new Error("The parameter 'firstVerse' cannot be null.");
        else if (firstVerse !== undefined)
            url_ += "firstVerse=" + encodeURIComponent("" + firstVerse) + "&";
        if (lastVerse !== undefined && lastVerse !== null)
            url_ += "lastVerse=" + encodeURIComponent("" + lastVerse) + "&";
        if (translationCode !== undefined && translationCode !== null)
            url_ += "translationCode=" + encodeURIComponent("" + translationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetKeywordScripture(_response));
        });
    }
    processGetKeywordScripture(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBibleFrame(signal) {
        let url_ = this.baseUrl + "/api/bible/frame";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBibleFrame(_response));
        });
    }
    processGetBibleFrame(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBibleTranslations(signal) {
        let url_ = this.baseUrl + "/api/bible";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBibleTranslations(_response));
        });
    }
    processGetBibleTranslations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBibleImageStyles(cursor, signal) {
        let url_ = this.baseUrl + "/api/bible/imagestyles?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBibleImageStyles(_response));
        });
    }
    processGetBibleImageStyles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserBusinessMemberApprovals(cursor, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserBusinessMemberApprovals(_response));
        });
    }
    processGetUserBusinessMemberApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBusinessBusinessMemberApprovals(businessProfileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/{businessProfileId}?";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBusinessBusinessMemberApprovals(_response));
        });
    }
    processGetBusinessBusinessMemberApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createBusinessMemberApproval(businessMemberApprovalResource, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(businessMemberApprovalResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateBusinessMemberApproval(_response));
        });
    }
    processCreateBusinessMemberApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBusinessMemberApproval(businessMemberApprovalId, updateBusinessMemberResource, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/{businessMemberApprovalId}";
        if (businessMemberApprovalId === undefined || businessMemberApprovalId === null)
            throw new Error("The parameter 'businessMemberApprovalId' must be defined.");
        url_ = url_.replace("{businessMemberApprovalId}", encodeURIComponent("" + businessMemberApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBusinessMemberResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateBusinessMemberApproval(_response));
        });
    }
    processUpdateBusinessMemberApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyBusinessMemberApproval(businessMemberApprovalId, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/destroy/{businessMemberApprovalId}";
        if (businessMemberApprovalId === undefined || businessMemberApprovalId === null)
            throw new Error("The parameter 'businessMemberApprovalId' must be defined.");
        url_ = url_.replace("{businessMemberApprovalId}", encodeURIComponent("" + businessMemberApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyBusinessMemberApproval(_response));
        });
    }
    processDestroyBusinessMemberApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    approveBusinessMemberApproval(businessMemberApprovalId, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/approve/{businessMemberApprovalId}";
        if (businessMemberApprovalId === undefined || businessMemberApprovalId === null)
            throw new Error("The parameter 'businessMemberApprovalId' must be defined.");
        url_ = url_.replace("{businessMemberApprovalId}", encodeURIComponent("" + businessMemberApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processApproveBusinessMemberApproval(_response));
        });
    }
    processApproveBusinessMemberApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    declineBusinessMemberApproval(businessMemberApprovalId, signal) {
        let url_ = this.baseUrl + "/api/businessmemberapproval/decline/{businessMemberApprovalId}";
        if (businessMemberApprovalId === undefined || businessMemberApprovalId === null)
            throw new Error("The parameter 'businessMemberApprovalId' must be defined.");
        url_ = url_.replace("{businessMemberApprovalId}", encodeURIComponent("" + businessMemberApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeclineBusinessMemberApproval(_response));
        });
    }
    processDeclineBusinessMemberApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserBusinessMembers(signal) {
        let url_ = this.baseUrl + "/api/businessmember";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserBusinessMembers(_response));
        });
    }
    processGetUserBusinessMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBusinessBusinessMembers(businessProfileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/businessmember/{businessProfileId}?";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBusinessBusinessMembers(_response));
        });
    }
    processGetBusinessBusinessMembers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBusinessMember(businessMemberId, updateBusinessMemberResource, signal) {
        let url_ = this.baseUrl + "/api/businessmember/{businessMemberId}";
        if (businessMemberId === undefined || businessMemberId === null)
            throw new Error("The parameter 'businessMemberId' must be defined.");
        url_ = url_.replace("{businessMemberId}", encodeURIComponent("" + businessMemberId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBusinessMemberResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateBusinessMember(_response));
        });
    }
    processUpdateBusinessMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyBusinessMember(businessMemberId, signal) {
        let url_ = this.baseUrl + "/api/businessmember/destroy/{businessMemberId}";
        if (businessMemberId === undefined || businessMemberId === null)
            throw new Error("The parameter 'businessMemberId' must be defined.");
        url_ = url_.replace("{businessMemberId}", encodeURIComponent("" + businessMemberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyBusinessMember(_response));
        });
    }
    processDestroyBusinessMember(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBusinessMemberNotificationPreferences(businessMemberId, signal) {
        let url_ = this.baseUrl + "/api/businessmember/notificationpreferences/{businessMemberId}";
        if (businessMemberId === undefined || businessMemberId === null)
            throw new Error("The parameter 'businessMemberId' must be defined.");
        url_ = url_.replace("{businessMemberId}", encodeURIComponent("" + businessMemberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBusinessMemberNotificationPreferences(_response));
        });
    }
    processGetBusinessMemberNotificationPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBusinessMemberNotificationPreferences(businessMemberId, notificationPreferencesResource, signal) {
        let url_ = this.baseUrl + "/api/businessmember/notificationpreferences/{businessMemberId}";
        if (businessMemberId === undefined || businessMemberId === null)
            throw new Error("The parameter 'businessMemberId' must be defined.");
        url_ = url_.replace("{businessMemberId}", encodeURIComponent("" + businessMemberId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(notificationPreferencesResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateBusinessMemberNotificationPreferences(_response));
        });
    }
    processUpdateBusinessMemberNotificationPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createBusinessProfile(createProfileResource, signal) {
        let url_ = this.baseUrl + "/api/business";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateBusinessProfile(_response));
        });
    }
    processCreateBusinessProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBusinessProfile(businessProfileId, updateProfileResource, signal) {
        let url_ = this.baseUrl + "/api/business/{businessProfileId}";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProfileResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateBusinessProfile(_response));
        });
    }
    processUpdateBusinessProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateBusinessProfileImage(businessProfileId, image, signal) {
        let url_ = this.baseUrl + "/api/business/image/{businessProfileId}";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateBusinessProfileImage(_response));
        });
    }
    processUpdateBusinessProfileImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyBusinessProfile(businessProfileId, disableProfileResource, signal) {
        let url_ = this.baseUrl + "/api/business/destroy/{businessProfileId}";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(disableProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyBusinessProfile(_response));
        });
    }
    processDestroyBusinessProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDevotionalComments(devotionalId, orderBy, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/devotional/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDevotionalComments(_response));
        });
    }
    processGetDevotionalComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPostComments(postId, orderBy, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/post/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetPostComments(_response));
        });
    }
    processGetPostComments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCommentResponses(commentId, cursor, businessProfileId, direction, signal) {
        let url_ = this.baseUrl + "/api/comment/comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetCommentResponses(_response));
        });
    }
    processGetCommentResponses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getComment(commentId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetComment(_response));
        });
    }
    processGetComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createDevotionalComment(devotionalId, businessProfileId, text, signal) {
        let url_ = this.baseUrl + "/api/comment/create/devotional/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(text);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateDevotionalComment(_response));
        });
    }
    processCreateDevotionalComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deprecatedCreateDevotionalComment(devotionalId, text, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/devotional/create/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeprecatedCreateDevotionalComment(_response));
        });
    }
    processDeprecatedCreateDevotionalComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createCommentComment(commentId, businessProfileId, text, signal) {
        let url_ = this.baseUrl + "/api/comment/create/comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(text);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateCommentComment(_response));
        });
    }
    processCreateCommentComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deprecatedCreateCommentComment(commentId, text, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/comment/create/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeprecatedCreateCommentComment(_response));
        });
    }
    processDeprecatedCreateCommentComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPostComment(postId, businessProfileId, text, signal) {
        let url_ = this.baseUrl + "/api/comment/create/post/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(text);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePostComment(_response));
        });
    }
    processCreatePostComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deprecatedCreatePostComment(postId, text, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/comment/post/create/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeprecatedCreatePostComment(_response));
        });
    }
    processDeprecatedCreatePostComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyComment(commentId, signal) {
        let url_ = this.baseUrl + "/api/comment/destroy/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyComment(_response));
        });
    }
    processDestroyComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateComment(id, text, signal) {
        let url_ = this.baseUrl + "/api/comment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(text);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateComment(_response));
        });
    }
    processUpdateComment(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    approveDevotionalApproval(devotionalApprovalId, signal) {
        let url_ = this.baseUrl + "/api/devotionalapproval/approve/{devotionalApprovalId}";
        if (devotionalApprovalId === undefined || devotionalApprovalId === null)
            throw new Error("The parameter 'devotionalApprovalId' must be defined.");
        url_ = url_.replace("{devotionalApprovalId}", encodeURIComponent("" + devotionalApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processApproveDevotionalApproval(_response));
        });
    }
    processApproveDevotionalApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    declineDevotionalApproval(devotionalApprovalId, approvalDeclineResource, signal) {
        let url_ = this.baseUrl + "/api/devotionalapproval/decline/{devotionalApprovalId}";
        if (devotionalApprovalId === undefined || devotionalApprovalId === null)
            throw new Error("The parameter 'devotionalApprovalId' must be defined.");
        url_ = url_.replace("{devotionalApprovalId}", encodeURIComponent("" + devotionalApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(approvalDeclineResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeclineDevotionalApproval(_response));
        });
    }
    processDeclineDevotionalApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBusinessDevotionalApprovals(businessProfileId, cursor, signal) {
        let url_ = this.baseUrl + "/api/devotionalapproval/{businessProfileId}?";
        if (businessProfileId === undefined || businessProfileId === null)
            throw new Error("The parameter 'businessProfileId' must be defined.");
        url_ = url_.replace("{businessProfileId}", encodeURIComponent("" + businessProfileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBusinessDevotionalApprovals(_response));
        });
    }
    processGetBusinessDevotionalApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDevotional(id, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/devotional/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDevotional(_response));
        });
    }
    processGetDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateDevotional(id, devotionalResource, signal) {
        let url_ = this.baseUrl + "/api/devotional/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(devotionalResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateDevotional(_response));
        });
    }
    processUpdateDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchDevotionals(query, pageNumber, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/devotional/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processSearchDevotionals(_response));
        });
    }
    processSearchDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProfileDevotionals(profileId, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/devotional/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetProfileDevotionals(_response));
        });
    }
    processGetProfileDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTagDevotionals(tagId, orderBy, pageNumber, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/devotional/tag/{tagId}?";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetTagDevotionals(_response));
        });
    }
    processGetTagDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDraftDevotionals(cursor, signal) {
        let url_ = this.baseUrl + "/api/devotional/drafts?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDraftDevotionals(_response));
        });
    }
    processGetDraftDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createDevotional(signal) {
        let url_ = this.baseUrl + "/api/devotional";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateDevotional(_response));
        });
    }
    processCreateDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    publishDevotional(id, devotionalResource, signal) {
        let url_ = this.baseUrl + "/api/devotional/publish/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(devotionalResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processPublishDevotional(_response));
        });
    }
    processPublishDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyDevotional(id, signal) {
        let url_ = this.baseUrl + "/api/devotional/destroy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyDevotional(_response));
        });
    }
    processDestroyDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getInProgressDevotional(id, signal) {
        let url_ = this.baseUrl + "/api/devotionalprogress/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetInProgressDevotional(_response));
        });
    }
    processGetInProgressDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getInProgressDevotionals(cursor, signal) {
        let url_ = this.baseUrl + "/api/devotionalprogress?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetInProgressDevotionals(_response));
        });
    }
    processGetInProgressDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    startDevotional(devotionalId, signal) {
        let url_ = this.baseUrl + "/api/devotionalprogress/start/{devotionalId}";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processStartDevotional(_response));
        });
    }
    processStartDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    stopDevotional(inProgressDevotionalId, signal) {
        let url_ = this.baseUrl + "/api/devotionalprogress/stop/{inProgressDevotionalId}";
        if (inProgressDevotionalId === undefined || inProgressDevotionalId === null)
            throw new Error("The parameter 'inProgressDevotionalId' must be defined.");
        url_ = url_.replace("{inProgressDevotionalId}", encodeURIComponent("" + inProgressDevotionalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processStopDevotional(_response));
        });
    }
    processStopDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    completeDevotionalDay(inProgressDevotionalId, devotionalDayId, signal) {
        let url_ = this.baseUrl + "/api/devotionalprogress/completeday/{inProgressDevotionalId}/{devotionalDayId}";
        if (inProgressDevotionalId === undefined || inProgressDevotionalId === null)
            throw new Error("The parameter 'inProgressDevotionalId' must be defined.");
        url_ = url_.replace("{inProgressDevotionalId}", encodeURIComponent("" + inProgressDevotionalId));
        if (devotionalDayId === undefined || devotionalDayId === null)
            throw new Error("The parameter 'devotionalDayId' must be defined.");
        url_ = url_.replace("{devotionalDayId}", encodeURIComponent("" + devotionalDayId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCompleteDevotionalDay(_response));
        });
    }
    processCompleteDevotionalDay(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    explore(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/explore?";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processExplore(_response));
        });
    }
    processExplore(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getNewsFeed(cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/feed?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetNewsFeed(_response));
        });
    }
    processGetNewsFeed(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDiscoverFeed(cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/feed/discover?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDiscoverFeed(_response));
        });
    }
    processGetDiscoverFeed(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProfileFeed(profileId, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/feed/profile/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetProfileFeed(_response));
        });
    }
    processGetProfileFeed(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPostShares(postId, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/feed/postshares/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetPostShares(_response));
        });
    }
    processGetPostShares(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDevotionalShares(devotionalId, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/feed/devotionalshares/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDevotionalShares(_response));
        });
    }
    processGetDevotionalShares(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFollowApprovals(cursor, signal) {
        let url_ = this.baseUrl + "/api/followapproval?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetFollowApprovals(_response));
        });
    }
    processGetFollowApprovals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    approveFollowApproval(followApprovalId, signal) {
        let url_ = this.baseUrl + "/api/followapproval/approve/{followApprovalId}";
        if (followApprovalId === undefined || followApprovalId === null)
            throw new Error("The parameter 'followApprovalId' must be defined.");
        url_ = url_.replace("{followApprovalId}", encodeURIComponent("" + followApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processApproveFollowApproval(_response));
        });
    }
    processApproveFollowApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    declineFollowApproval(followApprovalId, signal) {
        let url_ = this.baseUrl + "/api/followapproval/decline/{followApprovalId}";
        if (followApprovalId === undefined || followApprovalId === null)
            throw new Error("The parameter 'followApprovalId' must be defined.");
        url_ = url_.replace("{followApprovalId}", encodeURIComponent("" + followApprovalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeclineFollowApproval(_response));
        });
    }
    processDeclineFollowApproval(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFollowers(username, query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/follow/followers/{username}?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetFollowers(_response));
        });
    }
    processGetFollowers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFollowings(username, query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/follow/followings/{username}?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetFollowings(_response));
        });
    }
    processGetFollowings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createFollow(profileId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/follow/create/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateFollow(_response));
        });
    }
    processCreateFollow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyFollow(profileId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/follow/destroy/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyFollow(_response));
        });
    }
    processDestroyFollow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    removeFollower(profileId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/follow/remove/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processRemoveFollower(_response));
        });
    }
    processRemoveFollower(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getFonts(signal) {
        let url_ = this.baseUrl + "/api/font";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetFonts(_response));
        });
    }
    processGetFonts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getGifs(query, page, signal) {
        let url_ = this.baseUrl + "/api/gif?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetGifs(_response));
        });
    }
    processGetGifs(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPaymentIntent(createPaymentIntentResource, signal) {
        let url_ = this.baseUrl + "/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createPaymentIntentResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePaymentIntent(_response));
        });
    }
    processCreatePaymentIntent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getImages(query, page, signal) {
        let url_ = this.baseUrl + "/api/image?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetImages(_response));
        });
    }
    processGetImages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    triggerImageDownload(unsplashId, signal) {
        let url_ = this.baseUrl + "/api/image?";
        if (unsplashId !== undefined && unsplashId !== null)
            url_ += "unsplashId=" + encodeURIComponent("" + unsplashId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processTriggerImageDownload(_response));
        });
    }
    processTriggerImageDownload(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getDevotionalLikeProfiles(devotionalId, query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/devotional/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetDevotionalLikeProfiles(_response));
        });
    }
    processGetDevotionalLikeProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCommentLikeProfiles(commentId, query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/comment/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetCommentLikeProfiles(_response));
        });
    }
    processGetCommentLikeProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPostLikeProfiles(postId, query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/post/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetPostLikeProfiles(_response));
        });
    }
    processGetPostLikeProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createDevotionalLike(devotionalId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/devotional/create/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateDevotionalLike(_response));
        });
    }
    processCreateDevotionalLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createCommentLike(commentId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/comment/create/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateCommentLike(_response));
        });
    }
    processCreateCommentLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPostLike(postId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/post/create/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePostLike(_response));
        });
    }
    processCreatePostLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyDevotionalLike(devotionalId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/devotional/destroy/{devotionalId}?";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyDevotionalLike(_response));
        });
    }
    processDestroyDevotionalLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyCommentLike(commentId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/comment/destroy/{commentId}?";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyCommentLike(_response));
        });
    }
    processDestroyCommentLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyPostLike(postId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/like/post/destroy/{postId}?";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyPostLike(_response));
        });
    }
    processDestroyPostLike(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    uploadMedia(use, file, signal) {
        let url_ = this.baseUrl + "/api/media/upload?";
        if (use === null)
            throw new Error("The parameter 'use' cannot be null.");
        else if (use !== undefined)
            url_ += "use=" + encodeURIComponent("" + use) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUploadMedia(_response));
        });
    }
    processUploadMedia(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTrack(spotifyId, signal) {
        let url_ = this.baseUrl + "/api/music/{spotifyId}";
        if (spotifyId === undefined || spotifyId === null)
            throw new Error("The parameter 'spotifyId' must be defined.");
        url_ = url_.replace("{spotifyId}", encodeURIComponent("" + spotifyId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetTrack(_response));
        });
    }
    processGetTrack(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTracks(query, signal) {
        let url_ = this.baseUrl + "/api/music?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetTracks(_response));
        });
    }
    processGetTracks(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getNotifications(cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/notification?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetNotifications(_response));
        });
    }
    processGetNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUnreadNotificationCount(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/notification/count?";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUnreadNotificationCount(_response));
        });
    }
    processGetUnreadNotificationCount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    readNotifications(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/notification/read?";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processReadNotifications(_response));
        });
    }
    processReadNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    readNotification(notificationId, signal) {
        let url_ = this.baseUrl + "/api/notification/read/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processReadNotification(_response));
        });
    }
    processReadNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    deprecatedSeeNotifications(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/notification/see?";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDeprecatedSeeNotifications(_response));
        });
    }
    processDeprecatedSeeNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    addNotificationToken(notificationTokenResource, signal) {
        let url_ = this.baseUrl + "/api/notificationtoken";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(notificationTokenResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAddNotificationToken(_response));
        });
    }
    processAddNotificationToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyNotificationToken(notificationTokenResource, signal) {
        let url_ = this.baseUrl + "/api/notificationtoken/destroy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(notificationTokenResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyNotificationToken(_response));
        });
    }
    processDestroyNotificationToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    ping(signal) {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processPing(_response));
        });
    }
    processPing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPollVote(pollId, optionIndex, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/poll/vote/{pollId}/{optionIndex}?";
        if (pollId === undefined || pollId === null)
            throw new Error("The parameter 'pollId' must be defined.");
        url_ = url_.replace("{pollId}", encodeURIComponent("" + pollId));
        if (optionIndex === undefined || optionIndex === null)
            throw new Error("The parameter 'optionIndex' must be defined.");
        url_ = url_.replace("{optionIndex}", encodeURIComponent("" + optionIndex));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePollVote(_response));
        });
    }
    processCreatePollVote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPopUpInteractionExists(name, signal) {
        let url_ = this.baseUrl + "/api/popupinteraction/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetPopUpInteractionExists(_response));
        });
    }
    processGetPopUpInteractionExists(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPopUpInteraction(popUpInteractionResource, signal) {
        let url_ = this.baseUrl + "/api/popupinteraction";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(popUpInteractionResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePopUpInteraction(_response));
        });
    }
    processCreatePopUpInteraction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getPost(id, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/post/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetPost(_response));
        });
    }
    processGetPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updatePost(id, updatePostResource, signal) {
        let url_ = this.baseUrl + "/api/post/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePostResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdatePost(_response));
        });
    }
    processUpdatePost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPost(postResource, signal) {
        let url_ = this.baseUrl + "/api/post";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(postResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePost(_response));
        });
    }
    processCreatePost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyPost(id, signal) {
        let url_ = this.baseUrl + "/api/post/destroy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyPost(_response));
        });
    }
    processDestroyPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getScheduledPosts(cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/post/scheduled?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetScheduledPosts(_response));
        });
    }
    processGetScheduledPosts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    reschedulePost(id, timeZone, scheduledTime, signal) {
        let url_ = this.baseUrl + "/api/post/reschedule/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (timeZone !== undefined && timeZone !== null)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        if (scheduledTime !== undefined && scheduledTime !== null)
            url_ += "scheduledTime=" + encodeURIComponent("" + scheduledTime) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processReschedulePost(_response));
        });
    }
    processReschedulePost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createProfileBlock(profileId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profileblock/create/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateProfileBlock(_response));
        });
    }
    processCreateProfileBlock(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyProfileBlock(profileId, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profileblock/destroy/{profileId}?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyProfileBlock(_response));
        });
    }
    processDestroyProfileBlock(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getBlockedProfiles(query, cursor, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profileblock?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetBlockedProfiles(_response));
        });
    }
    processGetBlockedProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProfile(username, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profile/{username}?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetProfile(_response));
        });
    }
    processGetProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchProfiles(query, pageNumber, businessProfileId, profileSearchType, signal) {
        let url_ = this.baseUrl + "/api/profile/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        if (profileSearchType === null)
            throw new Error("The parameter 'profileSearchType' cannot be null.");
        else if (profileSearchType !== undefined)
            url_ += "profileSearchType=" + encodeURIComponent("" + profileSearchType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processSearchProfiles(_response));
        });
    }
    processSearchProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    exploreProfiles(pageNumber, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profile/explore?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processExploreProfiles(_response));
        });
    }
    processExploreProfiles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    isUsernameValid(username, signal) {
        let url_ = this.baseUrl + "/api/profile/username/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processIsUsernameValid(_response));
        });
    }
    processIsUsernameValid(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getProfileStatus(businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/profile/status?";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetProfileStatus(_response));
        });
    }
    processGetProfileStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createCommentReport(commentId, reportResource, signal) {
        let url_ = this.baseUrl + "/api/report/comment/create/{commentId}";
        if (commentId === undefined || commentId === null)
            throw new Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(reportResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateCommentReport(_response));
        });
    }
    processCreateCommentReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createDevotionalReport(devotionalId, reportResource, signal) {
        let url_ = this.baseUrl + "/api/report/devotional/create/{devotionalId}";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(reportResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateDevotionalReport(_response));
        });
    }
    processCreateDevotionalReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createProfileReport(profileId, reportResource, signal) {
        let url_ = this.baseUrl + "/api/report/profile/create/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(reportResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateProfileReport(_response));
        });
    }
    processCreateProfileReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createPostReport(postId, reportResource, signal) {
        let url_ = this.baseUrl + "/api/report/post/create/{postId}";
        if (postId === undefined || postId === null)
            throw new Error("The parameter 'postId' must be defined.");
        url_ = url_.replace("{postId}", encodeURIComponent("" + postId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(reportResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreatePostReport(_response));
        });
    }
    processCreatePostReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createResetPassword(emailAddress, signal) {
        let url_ = this.baseUrl + "/api/resetpassword/create?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateResetPassword(_response));
        });
    }
    processCreateResetPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    resolveResetPassword(id, resetPasswordResource, signal) {
        let url_ = this.baseUrl + "/api/resetpassword/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(resetPasswordResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processResolveResetPassword(_response));
        });
    }
    processResolveResetPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getSavedForLaterDevotionals(cursor, signal) {
        let url_ = this.baseUrl + "/api/savedforlaterdevotional?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetSavedForLaterDevotionals(_response));
        });
    }
    processGetSavedForLaterDevotionals(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createSavedForLaterDevotional(devotionalId, signal) {
        let url_ = this.baseUrl + "/api/savedforlaterdevotional/create/{devotionalId}";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateSavedForLaterDevotional(_response));
        });
    }
    processCreateSavedForLaterDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroySavedForLaterDevotional(devotionalId, signal) {
        let url_ = this.baseUrl + "/api/savedforlaterdevotional/destroy/{devotionalId}";
        if (devotionalId === undefined || devotionalId === null)
            throw new Error("The parameter 'devotionalId' must be defined.");
        url_ = url_.replace("{devotionalId}", encodeURIComponent("" + devotionalId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {}
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroySavedForLaterDevotional(_response));
        });
    }
    processDestroySavedForLaterDevotional(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    search(query, businessProfileId, signal) {
        let url_ = this.baseUrl + "/api/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (businessProfileId !== undefined && businessProfileId !== null)
            url_ += "businessProfileId=" + encodeURIComponent("" + businessProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processSearch(_response));
        });
    }
    processSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getTag(id, signal) {
        let url_ = this.baseUrl + "/api/tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetTag(_response));
        });
    }
    processGetTag(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    searchTags(query, pageNumber, signal) {
        let url_ = this.baseUrl + "/api/tag/search?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processSearchTags(_response));
        });
    }
    processSearchTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    createUserProfile(createProfileResource, signal) {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(createProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processCreateUserProfile(_response));
        });
    }
    processCreateUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCurrentUserProfile(signal) {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetCurrentUserProfile(_response));
        });
    }
    processGetCurrentUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserProfile(updateProfileResource, signal) {
        let url_ = this.baseUrl + "/api/user";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateProfileResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateUserProfile(_response));
        });
    }
    processUpdateUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getCurrentUserProfileRole(signal) {
        let url_ = this.baseUrl + "/api/user/role";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetCurrentUserProfileRole(_response));
        });
    }
    processGetCurrentUserProfileRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserProfilePrivacySettings(signal) {
        let url_ = this.baseUrl + "/api/user/privacy";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserProfilePrivacySettings(_response));
        });
    }
    processGetUserProfilePrivacySettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserPrivacySettings(updateSettingsResource, signal) {
        let url_ = this.baseUrl + "/api/user/privacy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateSettingsResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateUserPrivacySettings(_response));
        });
    }
    processUpdateUserPrivacySettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getUserProfileNotificationPreferences(signal) {
        let url_ = this.baseUrl + "/api/user/notificationpreferences";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetUserProfileNotificationPreferences(_response));
        });
    }
    processGetUserProfileNotificationPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserProfileNotificationPreferences(notificationPreferencesResource, signal) {
        let url_ = this.baseUrl + "/api/user/notificationpreferences";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(notificationPreferencesResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateUserProfileNotificationPreferences(_response));
        });
    }
    processUpdateUserProfileNotificationPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserProfileDevotionalReminder(notificationTime, signal) {
        let url_ = this.baseUrl + "/api/user/devotionalreminder?";
        if (notificationTime === null)
            throw new Error("The parameter 'notificationTime' cannot be null.");
        else if (notificationTime !== undefined)
            url_ += "notificationTime=" + encodeURIComponent("" + notificationTime) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateUserProfileDevotionalReminder(_response));
        });
    }
    processUpdateUserProfileDevotionalReminder(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateUserProfileBiblePreference(updateBibleResource, signal) {
        let url_ = this.baseUrl + "/api/user/bible";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updateBibleResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateUserProfileBiblePreference(_response));
        });
    }
    processUpdateUserProfileBiblePreference(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updatePassword(updatePasswordResource, signal) {
        let url_ = this.baseUrl + "/api/user/password";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(updatePasswordResource);
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdatePassword(_response));
        });
    }
    processUpdatePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    updateProfileImage(image, signal) {
        let url_ = this.baseUrl + "/api/user/image";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (image !== null && image !== undefined)
            content_.append("image", image.data, image.fileName ? image.fileName : "image");
        let options_ = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processUpdateProfileImage(_response));
        });
    }
    processUpdateProfileImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    temporarilyDisableUserProfile(disableUserProfileResource, signal) {
        let url_ = this.baseUrl + "/api/user/temporarilydisable";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(disableUserProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processTemporarilyDisableUserProfile(_response));
        });
    }
    processTemporarilyDisableUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    destroyUserProfile(disableUserProfileResource, signal) {
        let url_ = this.baseUrl + "/api/user/destroy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(disableUserProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processDestroyUserProfile(_response));
        });
    }
    processDestroyUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getWebLink(url, signal) {
        let url_ = this.baseUrl + "/api/weblink?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetWebLink(_response));
        });
    }
    processGetWebLink(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    getVideo(url, signal) {
        let url_ = this.baseUrl + "/api/youtube?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processGetVideo(_response));
        });
    }
    processGetVideo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBlockUsersDevices(username, signal) {
        let url_ = this.baseUrl + "/api/admin/blockdevice/user/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBlockUsersDevices(_response));
        });
    }
    processAdminBlockUsersDevices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBlockDevice(deviceId, signal) {
        let url_ = this.baseUrl + "/api/admin/blockdevice/device/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBlockDevice(_response));
        });
    }
    processAdminBlockDevice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnblockDevice(deviceId, signal) {
        let url_ = this.baseUrl + "/api/admin/blockdevice/remove/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnblockDevice(_response));
        });
    }
    processAdminUnblockDevice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBlockedDevices(signal) {
        let url_ = this.baseUrl + "/api/admin/blockdevice";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBlockedDevices(_response));
        });
    }
    processAdminGetBlockedDevices(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBlockUsersLatestIPAddress(username, signal) {
        let url_ = this.baseUrl + "/api/admin/blockipaddress/user/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBlockUsersLatestIPAddress(_response));
        });
    }
    processAdminBlockUsersLatestIPAddress(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminExpireIPAddressBlock(ipAddress, signal) {
        let url_ = this.baseUrl + "/api/admin/blockipaddress/expire?";
        if (ipAddress !== undefined && ipAddress !== null)
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminExpireIPAddressBlock(_response));
        });
    }
    processAdminExpireIPAddressBlock(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBlockedIPAddresses(signal) {
        let url_ = this.baseUrl + "/api/admin/blockipaddress";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBlockedIPAddresses(_response));
        });
    }
    processAdminGetBlockedIPAddresses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBlockUser(username, signal) {
        let url_ = this.baseUrl + "/api/admin/blockuser/user/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBlockUser(_response));
        });
    }
    processAdminBlockUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetBlockedUsers(signal) {
        let url_ = this.baseUrl + "/api/admin/blockuser";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetBlockedUsers(_response));
        });
    }
    processAdminGetBlockedUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBanBusinessProfile(banResource, signal) {
        let url_ = this.baseUrl + "/api/admin/businessprofile/ban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(banResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBanBusinessProfile(_response));
        });
    }
    processAdminBanBusinessProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnbanBusinessProfile(username, signal) {
        let url_ = this.baseUrl + "/api/admin/businessprofile/unban/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnbanBusinessProfile(_response));
        });
    }
    processAdminUnbanBusinessProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetSettings(signal) {
        let url_ = this.baseUrl + "/api/admin/settings";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetSettings(_response));
        });
    }
    processAdminGetSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUpdateSettings(settingsResource, signal) {
        let url_ = this.baseUrl + "/api/admin/settings";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(settingsResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUpdateSettings(_response));
        });
    }
    processAdminUpdateSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetTasks(signal) {
        let url_ = this.baseUrl + "/api/admin/task";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetTasks(_response));
        });
    }
    processAdminGetTasks(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminBanUserProfile(banResource, signal) {
        let url_ = this.baseUrl + "/api/admin/userprofile/ban";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(banResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminBanUserProfile(_response));
        });
    }
    processAdminBanUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminUnbanUserProfile(username, signal) {
        let url_ = this.baseUrl + "/api/admin/userprofile/unban/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminUnbanUserProfile(_response));
        });
    }
    processAdminUnbanUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminObscureUserProfile(obscureUseProfileResource, signal) {
        let url_ = this.baseUrl + "/api/admin/userprofile/obscure";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(obscureUseProfileResource);
        let options_ = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminObscureUserProfile(_response));
        });
    }
    processAdminObscureUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminCreateSupportNotification(id, signal) {
        let url_ = this.baseUrl + "/api/admin/userprofile/support?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminCreateSupportNotification(_response));
        });
    }
    processAdminCreateSupportNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetWarnings(cursor, query, status, type, orderBy, orderByDirection, signal) {
        let url_ = this.baseUrl + "/api/admin/warning?";
        if (cursor !== undefined && cursor !== null)
            url_ += "cursor=" + encodeURIComponent("" + cursor) + "&";
        if (query !== undefined && query !== null)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (orderBy === null)
            throw new Error("The parameter 'orderBy' cannot be null.");
        else if (orderBy !== undefined)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDirection === null)
            throw new Error("The parameter 'orderByDirection' cannot be null.");
        else if (orderByDirection !== undefined)
            url_ += "OrderByDirection=" + encodeURIComponent("" + orderByDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetWarnings(_response));
        });
    }
    processAdminGetWarnings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    adminGetProfileWarnings(profileId, signal) {
        let url_ = this.baseUrl + "/api/admin/warning/profile/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processAdminGetProfileWarnings(_response));
        });
    }
    processAdminGetProfileWarnings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
exports.GrowClient = GrowClient;
var EAlertType;
(function (EAlertType) {
    EAlertType["AttemptedProfanityUse"] = "AttemptedProfanityUse";
    EAlertType["AttemptedBlockedDomainUse"] = "AttemptedBlockedDomainUse";
    EAlertType["FailedLoginLockOut"] = "FailedLoginLockOut";
    EAlertType["CommentSpam"] = "CommentSpam";
})(EAlertType = exports.EAlertType || (exports.EAlertType = {}));
var EAlertAction;
(function (EAlertAction) {
    EAlertAction["CreatePost"] = "CreatePost";
    EAlertAction["CreateCommentComment"] = "CreateCommentComment";
    EAlertAction["CreateDevotionalComment"] = "CreateDevotionalComment";
    EAlertAction["CreatePostComment"] = "CreatePostComment";
    EAlertAction["CreateBusinessProfile"] = "CreateBusinessProfile";
    EAlertAction["CreateUserProfile"] = "CreateUserProfile";
    EAlertAction["UpdatePost"] = "UpdatePost";
    EAlertAction["UpdateComment"] = "UpdateComment";
    EAlertAction["UpdateBusinessProfile"] = "UpdateBusinessProfile";
    EAlertAction["UpdateUserProfile"] = "UpdateUserProfile";
    EAlertAction["PublishDevotional"] = "PublishDevotional";
    EAlertAction["GetWebLink"] = "GetWebLink";
    EAlertAction["ResolveDevotionalApproval"] = "ResolveDevotionalApproval";
    EAlertAction["Login"] = "Login";
    EAlertAction["CreatePoll"] = "CreatePoll";
})(EAlertAction = exports.EAlertAction || (exports.EAlertAction = {}));
var EProfileType;
(function (EProfileType) {
    EProfileType["User"] = "User";
    EProfileType["Business"] = "Business";
})(EProfileType = exports.EProfileType || (exports.EProfileType = {}));
var EAlertOrderBy;
(function (EAlertOrderBy) {
    EAlertOrderBy["Created"] = "Created";
})(EAlertOrderBy = exports.EAlertOrderBy || (exports.EAlertOrderBy = {}));
var EPagingOrderByDirection;
(function (EPagingOrderByDirection) {
    EPagingOrderByDirection["Ascending"] = "Ascending";
    EPagingOrderByDirection["Descending"] = "Descending";
})(EPagingOrderByDirection = exports.EPagingOrderByDirection || (exports.EPagingOrderByDirection = {}));
var EBusinessType;
(function (EBusinessType) {
    EBusinessType["Church"] = "Church";
    EBusinessType["Charity"] = "Charity";
    EBusinessType["Organisation"] = "Organisation";
    EBusinessType["MusicArtist"] = "MusicArtist";
    EBusinessType["Influencer"] = "Influencer";
    EBusinessType["Other"] = "Other";
})(EBusinessType = exports.EBusinessType || (exports.EBusinessType = {}));
var ECommentStatus;
(function (ECommentStatus) {
    ECommentStatus["Active"] = "Active";
    ECommentStatus["Deleted"] = "Deleted";
    ECommentStatus["DeletedByObjectOwner"] = "DeletedByObjectOwner";
    ECommentStatus["Banned"] = "Banned";
})(ECommentStatus = exports.ECommentStatus || (exports.ECommentStatus = {}));
var ECommentOrderBy;
(function (ECommentOrderBy) {
    ECommentOrderBy["Created"] = "Created";
    ECommentOrderBy["Likes"] = "Likes";
})(ECommentOrderBy = exports.ECommentOrderBy || (exports.ECommentOrderBy = {}));
var EWarningReason;
(function (EWarningReason) {
    EWarningReason["OffensiveLanguage"] = "OffensiveLanguage";
    EWarningReason["BullyingOrHarassment"] = "BullyingOrHarassment";
    EWarningReason["HateSpeechOrSymbols"] = "HateSpeechOrSymbols";
    EWarningReason["UnbiblicalViews"] = "UnbiblicalViews";
    EWarningReason["Spam"] = "Spam";
    EWarningReason["InsensitivityToAnEventOrSituation"] = "InsensitivityToAnEventOrSituation";
    EWarningReason["NudityOrSexualActivity"] = "NudityOrSexualActivity";
    EWarningReason["Violence"] = "Violence";
    EWarningReason["DisplayingFirearms"] = "DisplayingFirearms";
    EWarningReason["PromotionOfDrugsOrRegulatedGoods"] = "PromotionOfDrugsOrRegulatedGoods";
    EWarningReason["HarmfulFalseInformation"] = "HarmfulFalseInformation";
    EWarningReason["Impersonation"] = "Impersonation";
    EWarningReason["UnsolicitedFlirting"] = "UnsolicitedFlirting";
    EWarningReason["FakeEngagement"] = "FakeEngagement";
    EWarningReason["Scam"] = "Scam";
    EWarningReason["NonChristianBusiness"] = "NonChristianBusiness";
    EWarningReason["EngagingNegativelyWithMinors"] = "EngagingNegativelyWithMinors";
    EWarningReason["AskingForMoney"] = "AskingForMoney";
    EWarningReason["NewAccountAfterBeingSuspended"] = "NewAccountAfterBeingSuspended";
    EWarningReason["CopyrightViolation"] = "CopyrightViolation";
    EWarningReason["AbusiveTowardsGrowTeam"] = "AbusiveTowardsGrowTeam";
    EWarningReason["UnhelpfulOrUnkind"] = "UnhelpfulOrUnkind";
    EWarningReason["InappropriateImage"] = "InappropriateImage";
    EWarningReason["DoesNotBelongOnGrow"] = "DoesNotBelongOnGrow";
    EWarningReason["ContactingMinorsOutsideOfGrow"] = "ContactingMinorsOutsideOfGrow";
    EWarningReason["UnderTheAgeOfThirteen"] = "UnderTheAgeOfThirteen";
})(EWarningReason = exports.EWarningReason || (exports.EWarningReason = {}));
var EDevotionalStatus;
(function (EDevotionalStatus) {
    EDevotionalStatus["Draft"] = "Draft";
    EDevotionalStatus["PendingApproval"] = "PendingApproval";
    EDevotionalStatus["Published"] = "Published";
    EDevotionalStatus["Deleted"] = "Deleted";
    EDevotionalStatus["Banned"] = "Banned";
})(EDevotionalStatus = exports.EDevotionalStatus || (exports.EDevotionalStatus = {}));
var EDevotionalOrderBy;
(function (EDevotionalOrderBy) {
    EDevotionalOrderBy["Created"] = "Created";
})(EDevotionalOrderBy = exports.EDevotionalOrderBy || (exports.EDevotionalOrderBy = {}));
var EDevotionalCoverImageLayerType;
(function (EDevotionalCoverImageLayerType) {
    EDevotionalCoverImageLayerType["Text"] = "Text";
})(EDevotionalCoverImageLayerType = exports.EDevotionalCoverImageLayerType || (exports.EDevotionalCoverImageLayerType = {}));
var EDevotionalCoverImageTextLayerAlignment;
(function (EDevotionalCoverImageTextLayerAlignment) {
    EDevotionalCoverImageTextLayerAlignment["Right"] = "Right";
    EDevotionalCoverImageTextLayerAlignment["Center"] = "Center";
    EDevotionalCoverImageTextLayerAlignment["Left"] = "Left";
})(EDevotionalCoverImageTextLayerAlignment = exports.EDevotionalCoverImageTextLayerAlignment || (exports.EDevotionalCoverImageTextLayerAlignment = {}));
var EDevotionalElementType;
(function (EDevotionalElementType) {
    EDevotionalElementType["Title"] = "Title";
    EDevotionalElementType["Header"] = "Header";
    EDevotionalElementType["Paragraph"] = "Paragraph";
    EDevotionalElementType["Bible"] = "Bible";
    EDevotionalElementType["List"] = "List";
    EDevotionalElementType["Image"] = "Image";
    EDevotionalElementType["Music"] = "Music";
    EDevotionalElementType["YouTube"] = "YouTube";
    EDevotionalElementType["Gif"] = "Gif";
})(EDevotionalElementType = exports.EDevotionalElementType || (exports.EDevotionalElementType = {}));
var EVerseType;
(function (EVerseType) {
    EVerseType["Verse"] = "Verse";
    EVerseType["Header"] = "Header";
    EVerseType["LineBreak"] = "LineBreak";
})(EVerseType = exports.EVerseType || (exports.EVerseType = {}));
var EHeaderElementType;
(function (EHeaderElementType) {
    EHeaderElementType["Message"] = "Message";
    EHeaderElementType["Bible"] = "Bible";
    EHeaderElementType["Prayer"] = "Prayer";
    EHeaderElementType["Music"] = "Music";
    EHeaderElementType["Reflection"] = "Reflection";
    EHeaderElementType["Challenge"] = "Challenge";
    EHeaderElementType["Declaration"] = "Declaration";
})(EHeaderElementType = exports.EHeaderElementType || (exports.EHeaderElementType = {}));
var EListElementType;
(function (EListElementType) {
    EListElementType["Bullets"] = "Bullets";
    EListElementType["Numbered"] = "Numbered";
})(EListElementType = exports.EListElementType || (exports.EListElementType = {}));
var EFollowApprovalStatus;
(function (EFollowApprovalStatus) {
    EFollowApprovalStatus["PendingApproval"] = "PendingApproval";
    EFollowApprovalStatus["Approved"] = "Approved";
    EFollowApprovalStatus["Declined"] = "Declined";
})(EFollowApprovalStatus = exports.EFollowApprovalStatus || (exports.EFollowApprovalStatus = {}));
var EProfileStatus;
(function (EProfileStatus) {
    EProfileStatus["Active"] = "Active";
    EProfileStatus["Deleted"] = "Deleted";
    EProfileStatus["Banned"] = "Banned";
    EProfileStatus["TemporarilyDisabled"] = "TemporarilyDisabled";
})(EProfileStatus = exports.EProfileStatus || (exports.EProfileStatus = {}));
var EGlobalPushNotificationType;
(function (EGlobalPushNotificationType) {
    EGlobalPushNotificationType["SendAll"] = "SendAll";
    EGlobalPushNotificationType["Test"] = "Test";
})(EGlobalPushNotificationType = exports.EGlobalPushNotificationType || (exports.EGlobalPushNotificationType = {}));
var EGlobalPushNotificationStatus;
(function (EGlobalPushNotificationStatus) {
    EGlobalPushNotificationStatus["Pending"] = "Pending";
    EGlobalPushNotificationStatus["Complete"] = "Complete";
})(EGlobalPushNotificationStatus = exports.EGlobalPushNotificationStatus || (exports.EGlobalPushNotificationStatus = {}));
var EGlobalPushNotificationLinkObject;
(function (EGlobalPushNotificationLinkObject) {
    EGlobalPushNotificationLinkObject["Home"] = "Home";
    EGlobalPushNotificationLinkObject["Devotional"] = "Devotional";
    EGlobalPushNotificationLinkObject["Post"] = "Post";
    EGlobalPushNotificationLinkObject["Profile"] = "Profile";
})(EGlobalPushNotificationLinkObject = exports.EGlobalPushNotificationLinkObject || (exports.EGlobalPushNotificationLinkObject = {}));
var EGlobalPushNotificationOrderBy;
(function (EGlobalPushNotificationOrderBy) {
    EGlobalPushNotificationOrderBy["Created"] = "Created";
})(EGlobalPushNotificationOrderBy = exports.EGlobalPushNotificationOrderBy || (exports.EGlobalPushNotificationOrderBy = {}));
var EAdminLogAction;
(function (EAdminLogAction) {
    EAdminLogAction["MarkAlertAsSeen"] = "MarkAlertAsSeen";
    EAdminLogAction["MarkAlertAsUnseen"] = "MarkAlertAsUnseen";
    EAdminLogAction["BlockedDeviceById"] = "BlockedDeviceById";
    EAdminLogAction["RemovedBlockedDevice"] = "RemovedBlockedDevice";
    EAdminLogAction["ExpireUserSessions"] = "ExpireUserSessions";
    EAdminLogAction["BanComment"] = "BanComment";
    EAdminLogAction["VerifiedDevotional"] = "VerifiedDevotional";
    EAdminLogAction["UnverifiedDevotional"] = "UnverifiedDevotional";
    EAdminLogAction["BanDevotional"] = "BanDevotional";
    EAdminLogAction["AddPostToDiscoverFeed"] = "AddPostToDiscoverFeed";
    EAdminLogAction["RemovePostFromDiscoverFeed"] = "RemovePostFromDiscoverFeed";
    EAdminLogAction["BanPost"] = "BanPost";
    EAdminLogAction["UncensorPostImage"] = "UncensorPostImage";
    EAdminLogAction["CreateProfileWarning"] = "CreateProfileWarning";
    EAdminLogAction["BanBusinessProfile"] = "BanBusinessProfile";
    EAdminLogAction["BanUserProfile"] = "BanUserProfile";
    EAdminLogAction["TimeOutProfile"] = "TimeOutProfile";
    EAdminLogAction["BlockProfileLatestIPAddress"] = "BlockProfileLatestIPAddress";
    EAdminLogAction["BlockAllProfileDevices"] = "BlockAllProfileDevices";
    EAdminLogAction["UncensorProfileImage"] = "UncensorProfileImage";
    EAdminLogAction["ResolveReport"] = "ResolveReport";
    EAdminLogAction["UpdateSettings"] = "UpdateSettings";
    EAdminLogAction["CreateBusinessProfileBannedWarning"] = "CreateBusinessProfileBannedWarning";
    EAdminLogAction["CreateCommentWarning"] = "CreateCommentWarning";
    EAdminLogAction["CreateDevotionalWarning"] = "CreateDevotionalWarning";
    EAdminLogAction["CreatePostWarning"] = "CreatePostWarning";
    EAdminLogAction["ExpireTimeOut"] = "ExpireTimeOut";
    EAdminLogAction["ExpireIPAddressBlock"] = "ExpireIPAddressBlock";
    EAdminLogAction["RemoveBusinessProfileBannedWarning"] = "RemoveBusinessProfileBannedWarning";
    EAdminLogAction["RemoveCommentWarning"] = "RemoveCommentWarning";
    EAdminLogAction["RemoveDevotionalWarning"] = "RemoveDevotionalWarning";
    EAdminLogAction["RemovePostWarning"] = "RemovePostWarning";
    EAdminLogAction["RemoveProfileWarning"] = "RemoveProfileWarning";
    EAdminLogAction["UnbanBusinessProfile"] = "UnbanBusinessProfile";
    EAdminLogAction["UnbanComment"] = "UnbanComment";
    EAdminLogAction["UnbanDevotional"] = "UnbanDevotional";
    EAdminLogAction["UnbanPost"] = "UnbanPost";
    EAdminLogAction["UnbanUserProfile"] = "UnbanUserProfile";
    EAdminLogAction["ProtectedProfile"] = "ProtectedProfile";
    EAdminLogAction["UnprotectedProfile"] = "UnprotectedProfile";
    EAdminLogAction["CensorProfileImage"] = "CensorProfileImage";
    EAdminLogAction["CensorPostImage"] = "CensorPostImage";
    EAdminLogAction["SetUserProfileRole"] = "SetUserProfileRole";
    EAdminLogAction["SendSupportNotification"] = "SendSupportNotification";
    EAdminLogAction["CreatedGlobalPushNotification"] = "CreatedGlobalPushNotification";
    EAdminLogAction["CreatedTestGlobalPushNotification"] = "CreatedTestGlobalPushNotification";
    EAdminLogAction["ObscureUserProfile"] = "ObscureUserProfile";
})(EAdminLogAction = exports.EAdminLogAction || (exports.EAdminLogAction = {}));
var EAdminLogOrderBy;
(function (EAdminLogOrderBy) {
    EAdminLogOrderBy["Created"] = "Created";
})(EAdminLogOrderBy = exports.EAdminLogOrderBy || (exports.EAdminLogOrderBy = {}));
var ELoginType;
(function (ELoginType) {
    ELoginType["Login"] = "Login";
    ELoginType["Refresh"] = "Refresh";
})(ELoginType = exports.ELoginType || (exports.ELoginType = {}));
var EPostAttachmentType;
(function (EPostAttachmentType) {
    EPostAttachmentType["WebLink"] = "WebLink";
    EPostAttachmentType["Image"] = "Image";
    EPostAttachmentType["Music"] = "Music";
    EPostAttachmentType["Bible"] = "Bible";
    EPostAttachmentType["Gif"] = "Gif";
    EPostAttachmentType["Post"] = "Post";
    EPostAttachmentType["Devotional"] = "Devotional";
    EPostAttachmentType["Poll"] = "Poll";
})(EPostAttachmentType = exports.EPostAttachmentType || (exports.EPostAttachmentType = {}));
var EPostStatus;
(function (EPostStatus) {
    EPostStatus["Active"] = "Active";
    EPostStatus["Deleted"] = "Deleted";
    EPostStatus["Banned"] = "Banned";
})(EPostStatus = exports.EPostStatus || (exports.EPostStatus = {}));
var EPostType;
(function (EPostType) {
    EPostType["UserCreated"] = "UserCreated";
    EPostType["Action"] = "Action";
})(EPostType = exports.EPostType || (exports.EPostType = {}));
var EPostPublishedStatus;
(function (EPostPublishedStatus) {
    EPostPublishedStatus["Published"] = "Published";
    EPostPublishedStatus["Scheduled"] = "Scheduled";
})(EPostPublishedStatus = exports.EPostPublishedStatus || (exports.EPostPublishedStatus = {}));
var EPostOrderBy;
(function (EPostOrderBy) {
    EPostOrderBy["Created"] = "Created";
    EPostOrderBy["Published"] = "Published";
    EPostOrderBy["Comments"] = "Comments";
    EPostOrderBy["Likes"] = "Likes";
})(EPostOrderBy = exports.EPostOrderBy || (exports.EPostOrderBy = {}));
var EProfileOrderBy;
(function (EProfileOrderBy) {
    EProfileOrderBy["Created"] = "Created";
    EProfileOrderBy["Comments"] = "Comments";
    EProfileOrderBy["Followers"] = "Followers";
    EProfileOrderBy["Followings"] = "Followings";
    EProfileOrderBy["Likes"] = "Likes";
    EProfileOrderBy["Logins"] = "Logins";
    EProfileOrderBy["Posts"] = "Posts";
    EProfileOrderBy["ProfileBlocks"] = "ProfileBlocks";
})(EProfileOrderBy = exports.EProfileOrderBy || (exports.EProfileOrderBy = {}));
var EReportObjectType;
(function (EReportObjectType) {
    EReportObjectType["Post"] = "Post";
    EReportObjectType["Profile"] = "Profile";
    EReportObjectType["Devotional"] = "Devotional";
    EReportObjectType["Comment"] = "Comment";
})(EReportObjectType = exports.EReportObjectType || (exports.EReportObjectType = {}));
var EReportStatus;
(function (EReportStatus) {
    EReportStatus["Open"] = "Open";
    EReportStatus["Closed"] = "Closed";
})(EReportStatus = exports.EReportStatus || (exports.EReportStatus = {}));
var EReportType;
(function (EReportType) {
    EReportType["InappropriateLanguage"] = "InappropriateLanguage";
    EReportType["Unbiblical"] = "Unbiblical";
    EReportType["NudityOrSexualActivity"] = "NudityOrSexualActivity";
    EReportType["HateSpeech"] = "HateSpeech";
    EReportType["BullyingOrHarrassment"] = "BullyingOrHarrassment";
    EReportType["SuicideOrSelfHarm"] = "SuicideOrSelfHarm";
    EReportType["ScamOrFraud"] = "ScamOrFraud";
    EReportType["Spam"] = "Spam";
    EReportType["IntellectualPropertyViolation"] = "IntellectualPropertyViolation";
    EReportType["FalseInformation"] = "FalseInformation";
    EReportType["Impersonation"] = "Impersonation";
    EReportType["IJustDontLikeIt"] = "IJustDontLikeIt";
    EReportType["NewAccountAfterBeingSuspended"] = "NewAccountAfterBeingSuspended";
})(EReportType = exports.EReportType || (exports.EReportType = {}));
var EReportOrderBy;
(function (EReportOrderBy) {
    EReportOrderBy["Created"] = "Created";
})(EReportOrderBy = exports.EReportOrderBy || (exports.EReportOrderBy = {}));
var EResetPasswordStatus;
(function (EResetPasswordStatus) {
    EResetPasswordStatus["Pending"] = "Pending";
    EResetPasswordStatus["Completed"] = "Completed";
    EResetPasswordStatus["Expired"] = "Expired";
})(EResetPasswordStatus = exports.EResetPasswordStatus || (exports.EResetPasswordStatus = {}));
var ETimeFrame;
(function (ETimeFrame) {
    ETimeFrame["OneDay"] = "OneDay";
    ETimeFrame["SevenDays"] = "SevenDays";
    ETimeFrame["ThirtyDays"] = "ThirtyDays";
    ETimeFrame["OneYear"] = "OneYear";
    ETimeFrame["AllTime"] = "AllTime";
})(ETimeFrame = exports.ETimeFrame || (exports.ETimeFrame = {}));
var ETimeOutOrderBy;
(function (ETimeOutOrderBy) {
    ETimeOutOrderBy["Created"] = "Created";
})(ETimeOutOrderBy = exports.ETimeOutOrderBy || (exports.ETimeOutOrderBy = {}));
var EProfileDisableReason;
(function (EProfileDisableReason) {
    EProfileDisableReason["CantFindPeopleToFollow"] = "CantFindPeopleToFollow";
    EProfileDisableReason["TooBusyOrDistracting"] = "TooBusyOrDistracting";
    EProfileDisableReason["WantToRemoveSomething"] = "WantToRemoveSomething";
    EProfileDisableReason["CreatedASecondAccount"] = "CreatedASecondAccount";
    EProfileDisableReason["MediaFast"] = "MediaFast";
    EProfileDisableReason["TakingABreak"] = "TakingABreak";
    EProfileDisableReason["PrivacyConcerns"] = "PrivacyConcerns";
    EProfileDisableReason["NoLongerUseGrow"] = "NoLongerUseGrow";
    EProfileDisableReason["SomethingElse"] = "SomethingElse";
})(EProfileDisableReason = exports.EProfileDisableReason || (exports.EProfileDisableReason = {}));
var ECommentAppOrderBy;
(function (ECommentAppOrderBy) {
    ECommentAppOrderBy["Newest"] = "Newest";
    ECommentAppOrderBy["Oldest"] = "Oldest";
    ECommentAppOrderBy["Top"] = "Top";
})(ECommentAppOrderBy = exports.ECommentAppOrderBy || (exports.ECommentAppOrderBy = {}));
var KeysetPaginationDirection;
(function (KeysetPaginationDirection) {
    KeysetPaginationDirection["Forward"] = "Forward";
    KeysetPaginationDirection["Backward"] = "Backward";
})(KeysetPaginationDirection = exports.KeysetPaginationDirection || (exports.KeysetPaginationDirection = {}));
var EDevotionalApprovalStatus;
(function (EDevotionalApprovalStatus) {
    EDevotionalApprovalStatus["PendingApproval"] = "PendingApproval";
    EDevotionalApprovalStatus["Approved"] = "Approved";
    EDevotionalApprovalStatus["Declined"] = "Declined";
    EDevotionalApprovalStatus["DevotionalDeleted"] = "DevotionalDeleted";
})(EDevotionalApprovalStatus = exports.EDevotionalApprovalStatus || (exports.EDevotionalApprovalStatus = {}));
var EDevotionalSearchOrderBy;
(function (EDevotionalSearchOrderBy) {
    EDevotionalSearchOrderBy["Trending"] = "Trending";
    EDevotionalSearchOrderBy["Top"] = "Top";
    EDevotionalSearchOrderBy["ForYou"] = "ForYou";
    EDevotionalSearchOrderBy["New"] = "New";
})(EDevotionalSearchOrderBy = exports.EDevotionalSearchOrderBy || (exports.EDevotionalSearchOrderBy = {}));
var EInProgressDevotionalStatus;
(function (EInProgressDevotionalStatus) {
    EInProgressDevotionalStatus["InProgress"] = "InProgress";
    EInProgressDevotionalStatus["Completed"] = "Completed";
    EInProgressDevotionalStatus["Abandoned"] = "Abandoned";
    EInProgressDevotionalStatus["DevotionalDeleted"] = "DevotionalDeleted";
    EInProgressDevotionalStatus["ProfileBlocked"] = "ProfileBlocked";
    EInProgressDevotionalStatus["DevotionalBanned"] = "DevotionalBanned";
})(EInProgressDevotionalStatus = exports.EInProgressDevotionalStatus || (exports.EInProgressDevotionalStatus = {}));
var EFontCategory;
(function (EFontCategory) {
    EFontCategory["Serif"] = "Serif";
    EFontCategory["SansSerif"] = "SansSerif";
    EFontCategory["Display"] = "Display";
    EFontCategory["Handwriting"] = "Handwriting";
    EFontCategory["Monospace"] = "Monospace";
})(EFontCategory = exports.EFontCategory || (exports.EFontCategory = {}));
var EMediaType;
(function (EMediaType) {
    EMediaType["PostImage"] = "PostImage";
    EMediaType["DevotionalCoverImage"] = "DevotionalCoverImage";
    EMediaType["DevotionalCoverImageBackground"] = "DevotionalCoverImageBackground";
})(EMediaType = exports.EMediaType || (exports.EMediaType = {}));
var ENotificationGroupType;
(function (ENotificationGroupType) {
    ENotificationGroupType["PostComment"] = "PostComment";
    ENotificationGroupType["PostLike"] = "PostLike";
    ENotificationGroupType["PostShare"] = "PostShare";
    ENotificationGroupType["PostProfileTag"] = "PostProfileTag";
    ENotificationGroupType["CommentResponse"] = "CommentResponse";
    ENotificationGroupType["CommentLike"] = "CommentLike";
    ENotificationGroupType["CommentProfileTag"] = "CommentProfileTag";
    ENotificationGroupType["ProfileFollow"] = "ProfileFollow";
    ENotificationGroupType["ProfileFollowRequest"] = "ProfileFollowRequest";
    ENotificationGroupType["ProfileFollowRequestApproved"] = "ProfileFollowRequestApproved";
    ENotificationGroupType["DevotionalComment"] = "DevotionalComment";
    ENotificationGroupType["DevotionalLike"] = "DevotionalLike";
    ENotificationGroupType["DevotionalShare"] = "DevotionalShare";
    ENotificationGroupType["DevotionalApprovalRequest"] = "DevotionalApprovalRequest";
    ENotificationGroupType["DevotionalPublish"] = "DevotionalPublish";
    ENotificationGroupType["DevotionalApprovalDeclined"] = "DevotionalApprovalDeclined";
    ENotificationGroupType["BusinessMemberApprovalRequest"] = "BusinessMemberApprovalRequest";
    ENotificationGroupType["BusinessMemberApprovalRequestApproved"] = "BusinessMemberApprovalRequestApproved";
    ENotificationGroupType["AccountWarning"] = "AccountWarning";
    ENotificationGroupType["Support"] = "Support";
})(ENotificationGroupType = exports.ENotificationGroupType || (exports.ENotificationGroupType = {}));
var EPopUpInteractionResult;
(function (EPopUpInteractionResult) {
    EPopUpInteractionResult["Set"] = "Set";
    EPopUpInteractionResult["Cancel"] = "Cancel";
    EPopUpInteractionResult["Later"] = "Later";
})(EPopUpInteractionResult = exports.EPopUpInteractionResult || (exports.EPopUpInteractionResult = {}));
var EProfileSearchType;
(function (EProfileSearchType) {
    EProfileSearchType["User"] = "User";
    EProfileSearchType["Business"] = "Business";
    EProfileSearchType["All"] = "All";
})(EProfileSearchType = exports.EProfileSearchType || (exports.EProfileSearchType = {}));
var EWarningStatus;
(function (EWarningStatus) {
    EWarningStatus["Active"] = "Active";
    EWarningStatus["Removed"] = "Removed";
})(EWarningStatus = exports.EWarningStatus || (exports.EWarningStatus = {}));
var EWarningType;
(function (EWarningType) {
    EWarningType["BusinessProfile"] = "BusinessProfile";
    EWarningType["Comment"] = "Comment";
    EWarningType["Devotional"] = "Devotional";
    EWarningType["Post"] = "Post";
    EWarningType["Profile"] = "Profile";
})(EWarningType = exports.EWarningType || (exports.EWarningType = {}));
var EWarningOrderBy;
(function (EWarningOrderBy) {
    EWarningOrderBy["Created"] = "Created";
})(EWarningOrderBy = exports.EWarningOrderBy || (exports.EWarningOrderBy = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    throw new ApiException(message, status, response, headers, result);
}
// Created just to provide transformOptions and transformResult
class Client extends GrowClient {
    constructor() {
        super();
        this.transformOptions = (options) => {
            // Check if token has expired
            const expiryDate = localStorage["accessTokenExpiry"];
            if (expiryDate !== undefined && new Date(expiryDate) < new Date() && !Client.isTokenRefreshing) {
                Client.isTokenRefreshing = true;
                const refreshPromise = new Promise((resolve, reject) => {
                    this.refresh().then(() => {
                        this.updateRequestOptions(options);
                        resolve(options);
                    }).catch((error) => {
                        Client.failedToRefresh(error);
                        reject();
                    }).finally(() => Client.isTokenRefreshing = false);
                });
                Client.refreshPromise = refreshPromise;
                return refreshPromise;
            }
            else if (Client.isTokenRefreshing && Client.refreshPromise !== null) {
                // Wait for refresh
                return new Promise((resolve) => {
                    Client.refreshPromise.then(() => {
                        this.updateRequestOptions(options);
                        return resolve(options);
                    });
                });
            }
            else {
                this.updateRequestOptions(options);
                return Promise.resolve(options);
            }
        };
        this.updateRequestOptions = (options) => {
            const headers = (options === null || options === void 0 ? void 0 : options.headers) ? new Headers(options.headers) : new Headers();
            headers.set("Client", Client.clientName);
            headers.set("Language", navigator.language);
            headers.set("TimeZone", Intl.DateTimeFormat().resolvedOptions().timeZone);
            headers.set("TimeZoneOffset", (new Date().getTimezoneOffset() / 60).toString());
            if (Client.deviceId)
                headers.set("DeviceId", Client.deviceId);
            options.credentials = "include";
            options.headers = headers;
        };
    }
    // Override ping to not use transformOptions
    ping() {
        let url_ = this.getBaseUrl("", undefined) + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return fetch(url_, options_).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processPing(_response));
        });
    }
    // Override resolveResetPassword to not use transformOptions
    resolveResetPassword(id, resetPasswordResource) {
        let url_ = this.getBaseUrl("", undefined) + "/api/resetpassword/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(resetPasswordResource);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        return fetch(url_, options_).then((_response) => {
            return this.transformResult(url_, _response, (_response) => this.processResolveResetPassword(_response));
        });
    }
    transformResult(url, response, processor) {
        const expiryDate = localStorage["accessTokenExpiry"];
        // Set access token
        if ((url.indexOf("/api/auth/login") > -1 || url.indexOf("/api/auth/refresh") > -1) && response.status === 200) {
            return new Promise((resolve) => {
                processor(response).then((authToken) => {
                    this.setLoginCredentials(authToken);
                    Client.isTokenRefreshing = false;
                    resolve(authToken);
                });
            });
        }
        else if (response.status === 401 && expiryDate && new Date(expiryDate) >= new Date()) {
            const apiException = new ApiException("", response.status, "", response.headers, {});
            Client.failedToRefresh(apiException);
        }
        else {
            return processor(response);
        }
    }
    login(loginResource) {
        return new Promise((resolve, reject) => {
            super.login(loginResource).then((authToken) => {
                this.setLoginCredentials(authToken);
                resolve(authToken);
            }).catch((err) => {
                reject(err);
            });
        });
    }
    setLoginCredentials(authToken) {
        if (authToken.twoFactorAuthenticationRequired)
            return;
        const date = new Date();
        date.setSeconds(date.getSeconds() + authToken.expiresIn);
        localStorage["accessTokenExpiry"] = date;
    }
}
exports.default = Client;
Client.refreshPromise = null;
Client.deviceId = null;
